import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":5001/market/order";
};

// Shipping Method
export const mallCheckAvailableShippingMethod = params => {
  const url = `${baseURL()}/chkAvailableShipping`;

  return axios.post(url, params);
};

// Checkout
export const mallLoadOrderSummary = params => {
  const url = `${baseURL()}/summary`;

  return axios.post(url, params);
};

// Checkout
export const mallCheckoutOrder = params => {
  const url = `${baseURL()}/payment`;

  return axios.post(url, params);
};

// Order List
export const mallLoadOrderList = params => {
  const url = `${baseURL()}/orderList`;

  return axios.post(url, params);
};

// Order Detail
export const mallLoadOrderDetail = params => {
  const url = `${baseURL()}/orderDetail`;

  return axios.post(url, params);
};

// Complete Order
export const mallCompleteOrder = params => {
  const url = `${baseURL()}/completeOrder`;

  return axios.post(url, params);
};
